import { CreateSpineResources, Scale } from "../../../MyHelpers";
import { AwardJPShowElemntPIXAPP, AwardJPShowPIXAPP } from "./AwardJPShowPIXAPP";
import * as PIXI from "pixi.js";
import gsap from "gsap";

export class AwardJPShowElemntPIXAPPResponsive extends AwardJPShowElemntPIXAPP {
    public override CreatePIXIAPP() {
        this.awardDimmondSpine = [];
        this.viewPIXIAPP = new PIXI.Container();
        this.viewPIXIAPP.name = "AwardJPShowElementsContainerPIXIAPP";
        //let sizeSpine = new Size(0,0);
        for (var i = 0; i < 100; i++) {
            let award = CreateSpineResources(this.spinSpineJson);
            //award.state.setAnimation(0, "animation", true);                                    
            //award.tint = new PIXI.Color( JackpotProperties[Settings.JackpotDisplayType].jp3.color).toNumber();
            award.x = Math.random() * (window.innerWidth);
            award.y = Math.random() * (window.innerHeight);
            //award.alpha = Math.random() * 0.5 + 0.5;
            let scale = Math.random() * 0.5 + 0.5
            award.scale.set(Scale.XY(scale));
          
            award.pivot.set(award.width/2 , award.height/2);
            // Generate a random angle between 45 and 135 degrees
            var angle = Math.floor(Math.random() * (135 - 45 + 1 )) + 45 * -1;
            // Set the animation object's rotation to the random angle
            award.rotation = angle * Math.PI / 180;
            this.viewPIXIAPP.addChild(award);     
            this.awardDimmondSpine.push(award);   
            award.state.timeScale = scale;
        }


        let smallAwardScale = this.awardDimmondSpine.filter(ele=>ele.scale.x < 0.7);
        let bigAwardScale = this.awardDimmondSpine.filter(ele=>ele.scale.x > 0.7);

        // Animate the rain sprites using GSAP

        this.animSmallFallingAwards = gsap.timeline({ paused: true});

        this.animSmallFallingAwards.add(gsap.to(smallAwardScale, {
            duration: 5,
            ease: "none",
            y: "+=" + (window.innerHeight),
            modifiers: {
                y: function (y) {
                    return y % -(window.innerHeight);
                },
            },
            repeat: -1,
        }));


        this.animBigFallingAwards = gsap.timeline({ paused: true});
        // // Animate the rain sprites using GSAP
        this.animBigFallingAwards.add(gsap.to(bigAwardScale, {
            duration: 5,
            ease: "none",
            y: "+=" + (window.innerHeight),
            modifiers: {
                y: function (y) {
                    return y % -(window.innerHeight);
                },
            },
            repeat: -1,
        }));
    }
    
}